(() => {
  const init = (root) => {
    if (root.dataset.reviewFiltersReady) return;
    root.dataset.reviewFiltersReady = "true";
    const group = root.querySelector(".ttss-review-filters");
    const buttons = [...root.querySelectorAll("[data-review-filter]")];
    const cards = [...root.querySelectorAll("[data-review-product]")];
    const status = root.querySelector("[data-review-status]");
    if (!group || !cards.length) return;
    group.hidden = false;
    const filter = (value) => {
      buttons.forEach((button) => {
        button.setAttribute("aria-pressed", String(button.dataset.reviewFilter === value));
      });
      let visible = 0;
      cards.forEach((card) => {
        card.hidden = value !== "all" && card.dataset.reviewProduct !== value;
        if (!card.hidden) visible++;
      });
      const label = value === "all" ? "" : value === "her" ? " for For Her" : " for For Him";
      status.textContent = `${visible} selected ${visible === 1 ? "review" : "reviews"}${label}.`;
    };
    buttons.forEach((button) => button.addEventListener("click", () => filter(button.dataset.reviewFilter)));
    filter("all");
  };
  document.querySelectorAll("[data-ttss-home-reviews]").forEach(init);
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-ttss-home-reviews]").forEach(init);
  });
})();
